import { useUniqueFieldSuffix } from '../contexts/unique-field-suffix-context';
export function getInputId(fieldId, uniqueId) {
    return `form-field-input-${fieldId}-${uniqueId}`;
}
export function getLabelId(fieldId, uniqueId) {
    return `form-field-label-${fieldId}-${uniqueId}`;
}
export function getPrefixId(fieldId, uniqueId) {
    return `form-field-prefix-${fieldId}-${uniqueId}`;
}
export function getDescriptionId(fieldId, uniqueId) {
    return `form-field-description-${fieldId}-${uniqueId}`;
}
export function getErrorId(fieldId, uniqueId) {
    return `form-field-error-${fieldId}-${uniqueId}`;
}
export function getSuggestionId(fieldId, uniqueId) {
    return `form-field-suggestion-${fieldId}-${uniqueId}`;
}
export function getAriaDescribedBy({ errorId, error, suggestionId, suggestion, descriptionId, description }) {
    return [
        error && errorId,
        suggestion && suggestionId,
        description && descriptionId
    ].filter(Boolean).join(' ') || undefined;
}
export function getErrorDataHook(target) {
    return `field-error-${target}`;
}
export function getDescriptionDataHook(target) {
    return `field-description-${target}`;
}
export function useFieldAttributes(fieldId, error, description, suggestion) {
    const uniqueId = useUniqueFieldSuffix();
    const errorId = getErrorId(fieldId, uniqueId);
    const descriptionId = getDescriptionId(fieldId, uniqueId);
    const suggestionId = getSuggestionId(fieldId, uniqueId);
    return {
        inputId: getInputId(fieldId, uniqueId),
        labelId: getLabelId(fieldId, uniqueId),
        prefixId: getPrefixId(fieldId, uniqueId),
        descriptionId,
        errorId,
        suggestionId,
        ariaDescribedBy: getAriaDescribedBy({
            errorId,
            error,
            suggestionId,
            suggestion,
            descriptionId,
            description
        })
    };
}

//# sourceMappingURL=field-attributes.js.map